interface PagePurposeProps {
  title: string;
  audience: string;
  description: string;
  badge?: string;
}

export function PagePurpose({ title, audience, description, badge }: PagePurposeProps) {
  return (
    <section
      className="mb-8 rounded-2xl border bg-gradient-to-br from-[#F9FAFB] to-[#F4F7FC] p-6"
      style={{ borderColor: '#D4E2F4' }}
    >
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-3 flex-wrap">
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gray-500">
              Who should read this
            </p>
            {badge && (
              <span className="rounded-full bg-[#E0F2F1] px-3 py-1 text-xs font-semibold text-[#0F6B7C]">
                {badge}
              </span>
            )}
          </div>
          <h2 className="mt-2 text-lg font-semibold text-sb-black">{title}</h2>
          <p className="mt-2 text-sm text-gray-600">
            <strong className="font-semibold">For:</strong> {audience}
          </p>
          <p className="mt-1 text-sm text-gray-600">{description}</p>
        </div>
      </div>
    </section>
  );
}
